import React from 'react';
import PriceStart from '../components/Prices/start';
import PriceAccordion from '../components/Prices/priceAccordion';
import { PurchasePartners } from '../components/Prices/PurchasePartners';

function Price() {
  return (
    <>
    <div className='w-full bg-white overflow-hidden'>
      <div className='container mx-auto xl:px-4 py-8'>
        <PriceStart />
      </div>
    </div>
    <div className='w-full bg-white overflow-hidden '>
      <div className='container mx-auto xl:px-4 py-8'>
        <PriceAccordion />
      </div>
    </div>
    <div className='w-full bg-white overflow-hidden '>
      <div className='container mx-auto xl:px-4 py-8'>
        <PurchasePartners />
      </div>
    </div>
    </>
  );
}

export default Price; 